import script from "./CapabilityRow.vue?vue&type=script&setup=true&lang=js"
export * from "./CapabilityRow.vue?vue&type=script&setup=true&lang=js"

import "./CapabilityRow.vue?vue&type=style&index=0&id=34ed2811&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34ed2811"]])

export default __exports__